// extracted by mini-css-extract-plugin
export var bubble = "_3v-0";
export var container = "_3v-f";
export var contrastBorder = "_3v-g";
export var greyOut = "_3v-2";
export var initialsColor0 = "_3v-3";
export var initialsColor1 = "_3v-4";
export var initialsColor10 = "_3v-d";
export var initialsColor11 = "_3v-e";
export var initialsColor2 = "_3v-5";
export var initialsColor3 = "_3v-6";
export var initialsColor4 = "_3v-7";
export var initialsColor5 = "_3v-8";
export var initialsColor6 = "_3v-9";
export var initialsColor7 = "_3v-a";
export var initialsColor8 = "_3v-b";
export var initialsColor9 = "_3v-c";
export var initialsWrapper = "_3v-1";
export var large = "_3v-l";
export var medium = "_3v-k";
export var mediumSmall = "_3v-j";
export var mediumSmallMedium = "_3v-o";
export var micro = "_3v-h";
export var small = "_3v-i";
export var tiny = "_3v-n";
export var xTiny = "_3v-m";